import React, { useEffect, useState } from 'react'
import { Popover } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import { request } from 'meinian-package/src/utils'
import qs from 'qs'
import { TAB_ENUM, getTabOption } from '../common'
import { SwitchPageTab, SwitchTabBorder } from '../../../components/switchTab'
import styles from './index.module.less'

export default ({ params, value, onChange, cardTypeResult, onCardTypeChange }) => {
  const [preferenceTipVisible, setPreferenceTipVisible] = useState(false)
  const [preferenceOption, setPreferenceOption] = useState([])
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const result = await request.get('/zhikuan/mn/recommend/get-user-preference')
    if (result) {
      const _data = [
        { label: '行业偏好', value: result.gender, id: 1, },
        { label: '品类偏好', value: result.category, id: 2, },
        { label: '风格偏好', value: result.style, id: 3, },
        { label: '颜色偏好', value: result.color, id: 4, },
        { label: '设计要素', value: result.design, id: 5, }
      ]
      setPreferenceOption(_data)
    }
  }
  const preferenceTipContent = (
    <div className="preference-tip-content">
      <div className="preference-tip-content-title">整体偏好</div>
      {preferenceOption?.map(preferenceItem => <div className="preference-tip-content-item">
        <span style={{ color: 'var(--m-text-1)' }}>{preferenceItem.label}：</span>
        <span style={{ flex: '1 70%' }}>{preferenceItem.value}</span>
      </div>)}
    </div>
  )
  const tabOptions = getTabOption()

  useEffect(() => {
    if (tabOptions && tabOptions.length) {
      if (query?.tabValue) {
        onChange(+query.tabValue)
      } else {
        onChange(tabOptions[0].value, tabOptions[0])
      }
    }
  }, [])

  return <div className={styles['header-wrap']}>
    <div className="header-wrap-tab">
      <SwitchPageTab
        value={value}
        options={tabOptions}
        onChange={onChange}
        renderRight={() => <div className="header-wrap-tab-right">
          {
            TAB_ENUM.inspiration !== value && !!cardTypeResult.current.option.length && <SwitchTabBorder
              allowClear={cardTypeResult.current.allowClear}
              value={params.cardType}
              options={cardTypeResult.current.option}
              onChange={onCardTypeChange}
            />
          }
          {
              TAB_ENUM.inspiration !== value && !!preferenceOption.length && preferenceOption.filter(i => i.value).length >= 3 && <Popover
                visible={preferenceTipVisible}
                trigger={['click']}
                onVisibleChange={vis => setPreferenceTipVisible(vis)}
                placement="bottomRight"
                overlayClassName="preference-popover"
                content={preferenceTipContent}
                getPopupContainer={triggerNode => triggerNode.parentElement}
              >
                <div className="header-wrap-right">
                  <Icon type="m-pingfen" className="preference-icon" />
                  <span className="preference-item-tip">整体偏好</span>
                </div>
              </Popover>
          }
        </div>}
      />
    </div>
  </div>
}
